import { render, staticRenderFns } from "./PropertyCustomerNewScratchCustomer.vue?vue&type=template&id=21482b2b&scoped=true&lang=pug&"
import script from "./PropertyCustomerNewScratchCustomer.vue?vue&type=script&lang=js&"
export * from "./PropertyCustomerNewScratchCustomer.vue?vue&type=script&lang=js&"
import style0 from "./PropertyCustomerNewScratchCustomer.vue?vue&type=style&index=0&id=21482b2b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21482b2b",
  null
  
)

export default component.exports